module.exports = __webpack_public_path__ + "img/27_55.020e532c.png";